module.exports = __webpack_public_path__ + "img/Mitigating_Risk_With_an_Eye_Toward_Innovation.28c97eee.jpg";